var _rect, _g, _circle, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXhsQrExample(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    rx: 10,
    ry: 10,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 25,
    width: 20,
    height: 20,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 30,
    width: 10,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 20,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 25,
    width: 20,
    height: 20,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 30,
    width: 10,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 150,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 155,
    width: 20,
    height: 20,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 160,
    width: 10,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 20,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 20,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 20,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 20,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 20,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 20,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 30,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 30,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 30,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 30,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 30,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 40,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 40,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 40,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 40,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 50,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 50,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 50,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 50,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 50,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 60,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 60,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 60,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 60,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 70,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 70,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 70,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 70,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 80,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 80,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 80,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 80,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 90,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 90,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 90,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 90,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 100,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 100,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 100,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 100,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 110,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 110,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 110,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 110,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 120,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 120,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 120,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 120,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 130,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 130,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 130,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 130,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 140,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 140,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 140,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 140,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 150,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 150,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 150,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 150,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 160,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 160,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 160,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 160,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 170,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 170,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 170,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 170,
    width: 5,
    height: 5
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 20,
    fill: "#FF2442"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 105,
    fontFamily: "Arial",
    fontSize: 10,
    textAnchor: "middle",
    fill: "white"
  }, "XHS")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXhsQrExample);
export default __webpack_public_path__ + "static/media/xhs_qr_example.5dac1e65d7f314ea5dd2f66b80f28ce6.svg";
export { ForwardRef as ReactComponent };